import WidgetBase from "../common/widgetBase";
import Message from "./../common/message";
import { Converter } from "../../workspace/converter";

export default class MessageNode extends WidgetBase {
  renderBody() {
    const [messagesValue, notice] = this.loadObjectValue(
      this.props.data.component, "messages", "messages");
    if ( notice ) return this.renderNotice(notice);

    const messages = (() => {
      let msgs = messagesValue ? messagesValue["messages"] : null;
      if ( msgs ) {
        const maxMessages = Converter.getComponentPortValueData(this.props.data.component, "max_messages");
        if ( maxMessages ) {
          msgs = msgs.slice(0, maxMessages);
        }
      }
      return msgs;
    })();

    if ( !messages ) {
      return this.renderNotice({ variant: "warning", message: "The bound value has no messages to display." });
    }

    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");

    return (
      <>
        {messages.map((messageValue, index) => (
          <Message
            key={index}
            value={messageValue}
            contentView={contentView}
          />
        ))}
      </>
    );
  }
}
